import { AxiosError } from 'axios';
import { showErrorAlert } from '../helpers/alert';

type ApiErrorPayload = {
  message?: string;
  detail?: string;
  code?: string;
  errors?: any;
};

type HandleApiErrorOptions = {
  onUnauthorized?: (data?:any) => void;
  onForbidden?: (data:any) => void;
  onNotFound?: (data?:any) => void;
  onServerError?: (data?:any) => void;
  onBadRequest?: (data:any) => void;
};

export function handleApiError(
  error: unknown,
  options?: HandleApiErrorOptions
): any {
  const err = error as AxiosError<ApiErrorPayload>;

  if (!err.response) {
    throw {
      message: 'Network error. Please check your connection.',
      status: 0,
    };
  }

  const { status, data } = err.response;

  switch (status) {
    case 400:
      if(options?.onBadRequest){
        options?.onBadRequest?.(data);
      }else{
        let msg = parseApiErrors(data);
        showErrorAlert({ title: 'Error', message: msg })
      }
      break;
    case 401:
      if (data?.code === 'token_not_valid') {
        if(options?.onUnauthorized){
          options?.onUnauthorized?.();
        }else{
          showErrorAlert({ title: 'Error', message: 'Session expired. Please log in again.' })
        }
      }
      break;
    case 403:
      if(options?.onForbidden){
        options?.onForbidden?.(data);
      }else{
        showErrorAlert({ title: 'Error', message: 'You do not have permission to perform this action.' })
      }
      break;
    case 404:
      if(options?.onNotFound){
        options?.onNotFound?.();
      }else{
        showErrorAlert({ title: 'Error', message: 'Something went wrong. Please try again later.' })
      }
      break;
    case 500:
    default:
      if(options?.onServerError){
        options?.onServerError?.(data);
      }else{
        let msg = parseApiErrors(data);
        showErrorAlert({ title: 'Error', message: msg ?? 'Something went wrong. Please try again later.' })
      }
      break;
  }
}

type ErrorObject = Record<string, any>

export function parseApiErrors(errors: ErrorObject): string {
  if (!errors || typeof errors !== 'object') return ''

  const result: string[] = []

  const walk = (obj: any, parentKey = '') => {
    if (Array.isArray(obj)) {
      obj.forEach((item) => walk(item, parentKey))
      return
    }

    if (typeof obj === 'object' && obj !== null) {
      Object.entries(obj).forEach(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}.${key}` : key
        walk(value, fullKey)
      })
      return
    }

    if (typeof obj === 'string') {
      result.push(`${parentKey}: ${obj}`)
    }
  }

  walk(errors)

  return result.join(' <br><br> ')
}
